/**
 * Máscaras e validação para inputs BR (item 4.6 do lote 4).
 * Aplicado apenas na ENTRADA de novos dados / edição — não faz migração da base.
 */

export function digits(v) {
  return (v || "").toString().replace(/\D/g, "");
}

// CNPJ ---------------------------------------------------------------
export function maskCNPJ(v) {
  const d = digits(v).slice(0, 14);
  const p = [d.slice(0, 2), d.slice(2, 5), d.slice(5, 8), d.slice(8, 12), d.slice(12, 14)];
  let out = p[0];
  if (p[1]) out += "." + p[1];
  if (p[2]) out += "." + p[2];
  if (p[3]) out += "/" + p[3];
  if (p[4]) out += "-" + p[4];
  return out;
}

export function validCNPJ(v) {
  const c = digits(v);
  if (c.length !== 14 || /^(\d)\1+$/.test(c)) return false;
  const calc = (base) => {
    let sum = 0, pos = base.length - 7;
    for (let i = base.length; i >= 1; i--) {
      sum += Number(base.charAt(base.length - i)) * pos--;
      if (pos < 2) pos = 9;
    }
    const r = sum % 11;
    return r < 2 ? 0 : 11 - r;
  };
  const d1 = calc(c.slice(0, 12));
  const d2 = calc(c.slice(0, 13));
  return d1 === Number(c.charAt(12)) && d2 === Number(c.charAt(13));
}

// CEP ----------------------------------------------------------------
export function maskCEP(v) {
  const d = digits(v).slice(0, 8);
  return d.length > 5 ? `${d.slice(0, 5)}-${d.slice(5)}` : d;
}

export function validCEP(v) {
  return digits(v).length === 8;
}

// Telefone -----------------------------------------------------------
export function maskPhone(v) {
  const d = digits(v).slice(0, 11);
  if (d.length <= 10) {
    // (00) 0000-0000
    const p1 = d.slice(0, 2), p2 = d.slice(2, 6), p3 = d.slice(6, 10);
    if (!p1) return "";
    if (!p2) return `(${p1}`;
    if (!p3) return `(${p1}) ${p2}`;
    return `(${p1}) ${p2}-${p3}`;
  }
  // (00) 00000-0000
  const p1 = d.slice(0, 2), p2 = d.slice(2, 7), p3 = d.slice(7, 11);
  return `(${p1}) ${p2}-${p3}`;
}

export function validPhone(v) {
  const d = digits(v);
  return d.length >= 10 && d.length <= 11;
}
